import AppState from '../state';

const baseUrl = `${AppState.serverAddr}/configuracao`;

const handleResponse = (response) => {
  if (!response.ok) {
    return response.json().then((json) => {
      const error = new Error(response.status);
      error.response = json;
      throw error;
    });
  }

  return response.json();
};

const getActiveProjects = () => {
  return fetch(`${AppState.serverAddr}/projetos/GetActiveProjectList.php`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: AppState.token,
    },
  }).then(handleResponse);
};

const getConfiguracaoImpostos = () => {
  return fetch(`${baseUrl}/GetConfiguracaoImpostos.php`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: AppState.token,
    },
  }).then(handleResponse);
};

const updateConfiguracaoImpostos = (payload) => {
  return fetch(`${baseUrl}/UpdateConfiguracaoImpostos.php`, {
    method: 'POST',
    headers: {
      Authorization: AppState.token,
    },
    body: payload,
  }).then(handleResponse);
};

export {
  getActiveProjects,
  getConfiguracaoImpostos,
  updateConfiguracaoImpostos,
};